import styled from 'styled-components';
import { COLORS, SHADOWS } from '@/theme';
import { DatePicker, Input, InputNumber, Select } from '@/ui';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.GREY94};
      padding: 1rem 0.5rem;
      border-right: 1px solid ${COLORS.LIGHT_SILVER};
    }
    th:last-child {
      border-right: none;
    }
  }
`;

export const StyledInput = styled(Input)`
  box-shadow: ${SHADOWS.BOTTOM} !important;
`;

export const StyledNumberInput = styled(InputNumber)`
  box-shadow: ${SHADOWS.BOTTOM} !important;
`;

export const StyledSelect = styled(Select)`
  box-shadow: ${SHADOWS.BOTTOM} !important;

  &&& {
    .ant-select-selector {
      padding: 0 0.35rem;
      padding-right: 1.5rem;
    }
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  box-shadow: ${SHADOWS.BOTTOM} !important;
  height: 2rem;
`;
